import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { request } from "../api";

const initialRoute = "member/personal-health-score";
const { get } = request;

type QuestionaireQueryPayload = {
	SSN: string;
	group_number: number;
};

export const getPersonalHealthScoreHistoryBySSN = async (queryPayload: QuestionaireQueryPayload): Promise<any> => {
	try {
		const endpoint = `${initialRoute}/get-personal-health-score-history-by-ssn`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			queryPayload
		);

		if (response) {
			const {
				data: { message, result }
			} = response;
			if (message === MESSAGE.get.succ) return result;
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === 400) {
			const { err } = error.response.data;
			throw new Error(err);
		}
	}
};
